import React from 'react';
import { LightContainer, Flex, FlexColumn } from '../../Reusable/Container'
import { Checkbox } from 'antd';
import { Text } from '../../Reusable/Text'
import { LabeledInput } from '../../Reusable/Input'
import AionIcon from '../../../Images/aion-bank-icon.png'
import { toCurrency, getBPAccountsWithAccess, getFeaturePerm, getFeatureLimit } from '../../../Utils/util'

const OnlinePaymentsCard = ({
    onlinePaymentEnabled,
    fromAccount,
    options,
    handleChange,
    handleSelectAccount,
    toggleOnlinePayment,
}) => {
    const invoicePaymentPercent = parseFloat(getFeatureLimit("BusinessBanking.Fees.InvoicePaymentPercent"))
    const invoicePaymentCap = parseFloat(getFeatureLimit("BusinessBanking.Fees.InvoicePaymentCap"))

    return (
        <LightContainer className="radio-table" fullWidth>
            <Flex start style={{ cursor: 'pointer', marginBottom: 16 }} onClick={toggleOnlinePayment}>
                <Checkbox checked={onlinePaymentEnabled} onChange={handleChange} />
                <FlexColumn style={{ margin: '0 0 0 8px' }} gap="8px">
                    <Text size="16px" weight={onlinePaymentEnabled ? '700' : '400'}>Accept online payments</Text>
                    <Text lightText>Your customers can pay your invoice via bank transfer using Aion’s payment portal</Text>
                </FlexColumn>
            </Flex>

            {onlinePaymentEnabled && (
                <FlexColumn start gap="24px" style={{ marginBottom: 0 }}>
                    <Flex start style={{ paddingRight: 0 }}>
                        <LabeledInput
                            nomargin
                            label="Where would you like to receive payment?"
                            type="select"
                            id="fromAccount"
                            placeholder="Select account"
                            value={fromAccount && (
                                <Flex between centerHorizontally style={{ height: 30 }}>
                                    <Text>
                                        <img
                                            width="16px"
                                            height="16px"
                                            src={AionIcon}
                                            style={{ marginRight: 8, marginBottom: 2 }}
                                            alt="Aion"
                                        />
                                        {`${fromAccount.nickName || `Business ${fromAccount.accountSubType}`} • ${fromAccount.mask}`}
                                    </Text>
                                    <Text size="14px" lightText style={{ marginLeft: 8 }}>
                                        ${toCurrency(fromAccount.availableBalance)}
                                    </Text>
                                </Flex>
                            )}
                            onChange={handleSelectAccount}
                        >
                            {options}
                        </LabeledInput>
                    </Flex>

                    <LabeledInput
                        nomargin
                        label="Fees"
                        type="read-only"
                        placeholder="Select account"
                        value={`${invoicePaymentPercent}% of the payment amount, capped at $${invoicePaymentCap}`}
                    />
                </FlexColumn>
            )}
        </LightContainer>
    );
};

export default OnlinePaymentsCard;
